import React from 'react';
import {FaCheck} from "react-icons/fa";

const CheckPoint = ({...props}) => {
    return (
        <div className="flex flex-row items-start mb-4">
            <FaCheck className={"text-yellow-400 text-2xl mr-2 md:w-6"} />
            <div className="text-left flex-1">
                {props.children}
            </div>
        </div>
    )
}

export default CheckPoint;